"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllotmentsEditItem = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const valueForm_1 = require("../../../../hooks/valueForm");
const Remove_1 = require("../../../Button/Remove");
const Field_1 = require("../../../Form/Field");
const Tariff_1 = require("../../../Form/Field/Tariff");
const Sub_1 = require("../../../Page/Title/Sub");
require("./index.scss");
const className = 'allotments-edit-item';
const allotmentsEditItemConfig = (value) => ({
    type: 'object',
    shape: {
        agent: {
            type: 'object',
        },
        seatsNumber: {
            type: 'number',
            integer: true,
            positive: true,
        },
        costPerSeat: {
            type: 'number',
            roundedMoney: true,
            positive: true,
        },
        tariffGroup: {
            type: 'object',
            disabled: (value === null || value === void 0 ? void 0 : value.id) !== undefined,
        },
        comment: {
            type: 'string',
            optional: true,
        },
    },
});
const AllotmentsEditItem = (props) => {
    var _a;
    const { value, tariffGroups, config, onChange, remove, removeHidden, setValidateRef } = props;
    const { field, validateAll, } = (0, valueForm_1.useValueForm)({
        config: [allotmentsEditItemConfig, config],
        value,
        onChange,
    });
    setValidateRef === null || setValidateRef === void 0 ? void 0 : setValidateRef(validateAll);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__row` },
            react_1.default.createElement("div", { className: `${className}__title` },
                react_1.default.createElement(Sub_1.PageSubTitle, { text: (_a = field(['agent']).value) === null || _a === void 0 ? void 0 : _a.displayName })),
            react_1.default.createElement(Remove_1.RemoveButton, { onClick: remove, text: '', hidden: removeHidden })),
        react_1.default.createElement("div", { className: `${className}__row` },
            react_1.default.createElement("div", { className: `${className}__seats-number` },
                react_1.default.createElement(Field_1.FormFieldStable, { ...field(['seatsNumber']), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/ListEdit/Field:seatsNumber', defaultMessage: 'Seats' }) })),
            react_1.default.createElement("div", { className: `${className}__cost-per-seat` },
                react_1.default.createElement(Field_1.FormFieldStable, { ...field(['costPerSeat']), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Allotment/ListEdit/Field:costPerSeat', defaultMessage: 'Price' }), addon: 'CHF' })),
            react_1.default.createElement(Tariff_1.FormFieldTariff, { ...field(['tariffGroup']), items: tariffGroups }),
            react_1.default.createElement("div", { className: `${className}__comment` },
                react_1.default.createElement(Field_1.FormFieldStable, { ...field(['comment']), label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/Summary:Comment', defaultMessage: 'Comment' }) })))));
};
exports.AllotmentsEditItem = AllotmentsEditItem;
//# sourceMappingURL=index.js.map